/**
 * Wrapper for pages that must be reachable without signing in (FAQs, Accessibility, How-to, etc.).
 * Signed-out users see separate links: FAQs, Accessibility, Invitation & sign up, Sign up, Sign in.
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';
import './PublicPageShell.css';

const PublicPageShell = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <div className="public-page-shell">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <header className="public-page-shell-header" role="banner">
        <nav className="public-page-shell-nav" aria-label="Quick links">
          <SignedOut>
            {pathname !== '/faqs' && (
              <Link to="/faqs" className="public-page-shell-link">
                FAQs
              </Link>
            )}
            {pathname !== '/accessibility' && (
              <Link to="/accessibility" className="public-page-shell-link">
                Accessibility
              </Link>
            )}
            {pathname !== '/how-to' && (
              <Link to="/how-to" className="public-page-shell-link">
                Invitation &amp; sign up
              </Link>
            )}
            <Link to="/sign-up" className="public-page-shell-link">
              Sign up
            </Link>
            <Link to="/sign-in" className="public-page-shell-link public-page-shell-link-primary">
              Sign in
            </Link>
          </SignedOut>
          <SignedIn>
            <Link to="/" className="public-page-shell-link">
              App home
            </Link>
            <UserButton />
          </SignedIn>
        </nav>
      </header>
      <main id="main-content" className="public-page-shell-main">
        {children}
      </main>
    </div>
  );
};

export default PublicPageShell;
